var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Recent/14x14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 13.9995 0 13.9995 13.9999 0 13.9999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Recent/14x14",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9995,11.99 C4.2485,11.99 2.0095,9.751 2.0095,7 C2.0095,4.248 4.2485,2.01 6.9995,2.01 C9.7515,2.01 11.9905,4.248 11.9905,7 C11.9905,9.751 9.7515,11.99 6.9995,11.99 M6.9995,0 C3.1395,0 -0.0005,3.14 -0.0005,7 C-0.0005,10.859 3.1395,14 6.9995,14 C10.8595,14 13.9995,10.859 13.9995,7 C13.9995,3.14 10.8595,0 6.9995,0",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.0281,6.3814 L7.7841,6.3814 L7.7841,4.2724 C7.7841,3.7184 7.3341,3.2684 6.7791,3.2684 C6.2231,3.2684 5.7741,3.7184 5.7741,4.2724 L5.7741,7.2224 C5.7741,7.2514 5.7881,7.2764 5.7901,7.3044 C5.7881,7.3324 5.7741,7.3574 5.7741,7.3864 C5.7741,7.9414 6.2231,8.3914 6.7791,8.3914 L9.0281,8.3914 C9.5831,8.3914 10.0331,7.9414 10.0331,7.3864 C10.0331,6.8314 9.5831,6.3814 9.0281,6.3814",
    id: "Fill-4",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.a9d9bdfebe61ff61beda024abc313e47.svg";
export { ForwardRef as ReactComponent };